// English catalog. The Ukrainian catalog (uk.ts) must have exactly the same keys (SPEC §10.2).

export const en = {
  app: {
    productName: "WebUniverse",
    loading: "Loading…",
    readOnly: "Read-only",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    archive: "Archive",
    unarchive: "Unarchive",
    archived: "Archived",
    edit: "Edit",
    add: "Add",
    remove: "Remove",
    create: "Create",
    search: "Search",
    showArchived: "Show archived",
    none: "—",
    allDay: "All day",
    noPeriods: "No unavailability.",
    saveAnyway: "Save anyway",
    reload: "Reload",
    previous: "Previous",
    next: "Next",
    today: "Today",
    tomorrow: "Tomorrow",
    thisWeek: "This week",
    date: "Date",
    from: "From",
    to: "To",
    time: "Time",
    start: "Start",
    end: "End",
    length: "Length",
    note: "Note",
    reason: "Reason",
    name: "Name",
    actions: "Actions",
    yes: "Yes",
    no: "No",
    saved: "Saved",
    deleted: "Deleted",
    notFound: "This page does not exist.",
    forbidden: "You don't have access to this page.",
    goHome: "Go to the home screen",
    unknownError: "Unknown error ({code})",
    networkError: "The server can't be reached. Check your connection and try again.",
    concurrentEdit: "Someone else changed this. Reload to see the latest version.",
    sessionExpired: "Your session ended. Sign in again.",
  },
  nav: {
    dayView: "Day view",
    groups: "Groups",
    teachers: "Teachers",
    changes: "Changes",
    admin: "Admin",
    centers: "Centers & classrooms",
    courses: "Courses",
    users: "Users",
    travelTimes: "Travel times",
    mySchedule: "My schedule",
    notifications: "Notifications",
    changePassword: "Change password",
    signOut: "Sign out",
    language: "Language",
    theme: "Theme",
    menu: "Menu",
  },
  theme: {
    light: "Light",
    dark: "Dark",
    system: "System",
  },
  signIn: {
    title: "Sign in",
    username: "Username",
    password: "Password",
    submit: "Sign in",
  },
  password: {
    title: "Change password",
    current: "Current password",
    new: "New password",
    repeat: "Repeat new password",
    mismatch: "The two new passwords differ.",
    changed: "Your password was changed.",
  },
  day: {
    title: "Day view",
    center: "Center",
    noCenters: "No centers yet. Add one under Admin → Centers & classrooms.",
    noClassrooms: "This center has no classrooms.",
    closed: "Center closed ({reason})",
    overlapWarning: "Overlapping lessons",
    allCenters: "All centers",
    view: "View",
    viewGrid: "Grid",
    viewList: "List",
    attentionTitle: "Needs attention",
    nothingNeedsAttention: "Nothing needs attention.",
    noLessons: "No lessons.",
    insteadOf: "instead of {name}",
  },
  lessonFlags: {
    substituted: "Substitute",
    cancelled: "Cancelled",
    moved: "Moved",
    roomChanged: "Room changed",
    problem: "Problem",
    centerClosed: "Center closed",
    unavailable: "Unavailable",
  },
  groups: {
    title: "Groups",
    newGroup: "New group",
    name: "Name",
    course: "Course",
    mainTeacher: "Main teacher",
    room: "Room",
    slots: "Weekly slots",
    startDate: "Start date",
    endDate: "End date",
    currentPlan: "Current plan",
    periods: "Plan history",
    validFrom: "Valid from",
    lessons: "Lessons",
    findReplacement: "Find replacement",
    changePlan: "Change plan",
    applyFrom: "Apply from",
    editIdentity: "Edit name, note, end date",
    addSlot: "Add slot",
    removeSlot: "Remove",
    day: "Day",
    notQualified: "not qualified",
    created: "Group created.",
    planSaved: "Plan saved. Lessons checked from {from} to {to}.",
    orphansTitle: "These lesson changes would be left without a lesson:",
    deleteOrphans: "Delete them and save",
    noGroups: "No groups.",
    archivedOn: "Archived on {date}",
  },
  lesson: {
    title: "Lesson",
    group: "Group",
    course: "Course",
    teacher: "Teacher",
    mainTeacher: "Main teacher",
    room: "Room",
    center: "Center",
    movedFrom: "moved from {time}",
    note: "Note (admins only)",
    teacherNote: "Note for teacher",
    cancel: "Cancel lesson",
    restore: "Restore lesson",
    changeRoom: "Change room",
    resetRoom: "Reset room",
    moveTime: "Move time",
    resetTime: "Reset time",
    editNote: "Edit note",
    editTeacherNote: "Edit note for teacher",
    backToMainTeacher: "Back to main teacher",
    candidates: "Candidates",
    rank: "#",
    score: "Score",
    reasons: "Reasons",
    contacts: "Contacts",
    assign: "Assign",
    showExcluded: "Show {count} excluded",
    hideExcluded: "Hide excluded",
    nobody: "Nobody is free and qualified.",
    history: "History",
    noHistory: "No changes yet.",
    conflictsTitle: "This change conflicts with the schedule:",
    closedNoCandidates: "The center is closed that day, so nobody is offered. You can move the lesson to another room.",
    dataProblems: "Data problems",
  },
  teachers: {
    title: "Teachers",
    newTeacher: "New teacher",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    email: "Email",
    telegram: "Telegram",
    courses: "Courses",
    ownGroups: "Groups",
    contacts: "Contacts",
    week: "Week",
    weeklyUnavailable: "Weekly unavailability",
    addWeekly: "Add weekly time",
    unavailability: "Unavailability",
    addPeriod: "Add unavailability",
    affectedTitle: "Lessons affected by this unavailability:",
    noAffected: "No lessons are affected.",
    conflictBanner: "Lessons this week during unavailable time:",
    createLogin: "Create login",
    loginStatus: "Login: {username}, {status}",
    active: "active",
    inactive: "inactive",
    noTeachers: "No teachers.",
  },
  changes: {
    title: "Changes",
    entityType: "Record type",
    allTypes: "All",
    when: "When",
    who: "Who",
    what: "What",
    record: "Record",
    details: "Details",
    page: "Page {page} of {pages}",
    empty: "No changes in this period.",
  },
  admin: {
    centers: "Centers",
    addCenter: "Add center",
    address: "Address",
    closures: "Closures",
    noClosures: "No closures.",
    addClosure: "Add closure",
    alsoAllCenters: "Also add to all other centers",
    lessonsNotTakingPlace: "These lessons will not take place:",
    travelTimes: "Travel times",
    travelHelp: "Minutes between centers. Leave blank to use the default ({minutes} min).",
    classrooms: "Classrooms",
    addClassroom: "Add classroom",
    capacity: "Capacity",
    courses: "Courses",
    addCourse: "Add course",
    teacherCount: "Teachers",
    groupCount: "Groups",
    users: "Users",
    addUser: "Add account",
    username: "Username",
    displayName: "Display name",
    role: "Role",
    linkedTeacher: "Teacher",
    lastLogin: "Last login",
    status: "Status",
    initialPassword: "Initial password",
    deactivate: "Deactivate",
    activate: "Activate",
    resetPassword: "Reset password",
    newPassword: "New password",
    passwordReset: "Password reset.",
    allRoles: "All roles",
    deleteConfirm: "Delete for good? Click again to confirm.",
  },
  mySchedule: {
    title: "My schedule",
    list: "List",
    grid: "Week",
    upcoming: "Next 14 days",
    nothing: "No lessons in the next 14 days.",
    substitutingFor: "Substituting for {name}",
    coveredBy: "Covered by {name}",
    noteForYou: "Note: {note}",
  },
  notifications: {
    title: "Notifications",
    seeAll: "See all",
    markAllRead: "Mark all read",
    empty: "No notifications.",
    unreadOnly: "Unread only",
  },
  errors: {
    UNAUTHORIZED: "Please sign in.",
    FORBIDDEN: "You don't have access to this.",
    INVALID_CREDENTIALS: "Invalid username or password",
    TOO_MANY_ATTEMPTS: "Too many failed attempts. Wait 5 minutes and try again.",
    FORBIDDEN_SELF_DEACTIVATE: "You can't deactivate your own account.",
    LAST_ADMIN: "There must always be at least one active admin.",
    NOT_FOUND: "Not found.",
    VALIDATION_FAILED: "Please correct the highlighted fields.",
    CONCURRENT_EDIT: "Someone else changed this. Reload to see the latest version.",
    IN_USE: "Still in use ({references}). Archive it instead.",
    SCHEDULE_CONFLICTS: "The change conflicts with the schedule.",
    ORPHANED_LESSON_CHANGES: "Some lesson changes would be left without a lesson.",
    PERIOD_BEFORE_LATEST: "The plan can only change from the latest plan's date or later.",
    PERIOD_IN_PAST: "The plan can only change from today or later; past lessons keep their plan.",
    LESSON_NOT_ON_DATE: "The group has no such lesson on that date.",
    LESSON_CANCELLED: "The lesson is cancelled.",
    INTERNAL_ERROR: "Something went wrong on the server.",
  },
  fieldErrors: {
    REQUIRED: "Required",
    TOO_LONG: "At most {max} characters",
    TOO_SHORT: "At least {min} characters",
    UNKNOWN_REFERENCE: "Not found",
    ARCHIVED_REFERENCE: "Archived — choose another",
    RANGE_INVALID: "Invalid time",
    DATE_RANGE_INVALID: "The end is before the start",
    DATE_IN_PAST: "Can't be earlier than yesterday: past lessons would disappear",
    DATE_RANGE_TOO_LONG: "At most {maxDays} days",
    SLOTS_OVERLAP: "Overlaps another slot",
    DUPLICATE_NAME: "This name is already used",
    PASSWORD_TOO_SHORT: "At least {min} characters",
    WRONG_PASSWORD: "Wrong password",
    TEACHER_REQUIRED_FOR_ROLE: "Choose the teacher",
    TEACHER_NOT_ALLOWED_FOR_ROLE: "Only teacher accounts link a teacher",
    TEACHER_HAS_ACCOUNT: "This teacher already has an account",
    DUPLICATE_USERNAME: "This username is taken",
    REASON_NOT_ALLOWED: "This reason can't be used here",
    USERNAME_INVALID: "3–50 letters, digits, '.', '_' or '-'",
    DUPLICATE_PAIR: "This pair of centers is listed twice",
  },
  conflicts: {
    TEACHER_DOUBLE_BOOKED: "The teacher already teaches {otherLesson} then",
    ROOM_DOUBLE_BOOKED: "The room is used by {otherLesson} then",
    TEACHER_NOT_QUALIFIED: "The teacher is not qualified for this course",
    TEACHER_UNAVAILABLE: "The teacher is unavailable ({reason}, {range})",
    ROOM_UNAVAILABLE: "The room is unavailable ({reason}, {range})",
    CENTER_CLOSED: "The center is closed that day ({reason})",
  },
  exclusions: {
    CURRENT_TEACHER: "Teaches this lesson",
    ARCHIVED: "Archived",
    NOT_QUALIFIED: "Not qualified for this course",
    UNAVAILABLE: "Unavailable ({reason}, {range})",
    BUSY: "Busy: {lesson}",
    CANT_TRAVEL: "Can't get there in time: {lesson}, {gapMinutes} min gap, needs {travelMinutes} min",
  },
  reasons: {
    BASE: "Base",
    SAME_CENTER_ADJACENT: "Already at this center ({lesson})",
    TRAVEL: "Travel: {gapMinutes} min gap, needs {travelMinutes} min ({lesson})",
    KNOWS_GROUP: "Knows the group (last {lastDate})",
    RECENT_SUBSTITUTIONS: "Recent substitutions: {count}",
    DAY_LOAD: "Lessons that day: {count}",
  },
  dataProblems: {
    MISSING_TEACHER: "Missing teacher",
    MISSING_CLASSROOM: "Missing classroom",
    MISSING_CENTER: "Missing center",
    MISSING_COURSE: "Missing course",
  },
  gridProblems: {
    LessonDuringUnavailableTime: "{lesson} is during unavailable time",
    LessonsOverlap: "{lesson} overlaps {otherLesson}",
  },
  actions: {
    LESSON_CANCELLED: "Cancelled the lesson",
    LESSON_RESTORED: "Restored the lesson",
    SUBSTITUTE_ASSIGNED: "Assigned a substitute",
    SUBSTITUTE_REMOVED: "Went back to the main teacher",
    ROOM_CHANGED: "Changed the room",
    ROOM_RESET: "Went back to the default room",
    TIME_CHANGED: "Moved the lesson",
    TIME_RESET: "Went back to the planned time",
    NOTE_CHANGED: "Changed the note",
    TEACHER_NOTE_CHANGED: "Changed the note for the teacher",
    UNAVAILABILITY_ADDED: "Added unavailability",
    UNAVAILABILITY_REMOVED: "Removed unavailability",
    GROUP_CREATED: "Created the group",
    GROUP_PLAN_CHANGED: "Changed the group plan",
    GROUP_UPDATED: "Edited the group",
    LESSON_CHANGES_ORPHAN_DELETED: "Deleted a lesson change left without a lesson",
    RECORD_CREATED: "Created",
    RECORD_UPDATED: "Edited",
    RECORD_ARCHIVED: "Archived",
    RECORD_UNARCHIVED: "Unarchived",
    RECORD_DELETED: "Deleted",
    USER_CREATED: "Created the account",
    USER_DEACTIVATED: "Deactivated the account",
    USER_ACTIVATED: "Activated the account",
    PASSWORD_CHANGED: "Changed their password",
    PASSWORD_RESET: "Reset the password",
    CENTER_CLOSURE_ADDED: "Added a closure",
    CENTER_CLOSURE_REMOVED: "Removed a closure",
    TRAVEL_TIMES_CHANGED: "Changed travel times",
  },
  notificationTypes: {
    YOU_SUBSTITUTE: "You substitute in {groupName} on {date}, {range}",
    YOU_NO_LONGER_SUBSTITUTE: "You no longer substitute in {groupName} on {date}",
    YOUR_LESSON_COVERED: "{substituteName} covers your {groupName} lesson on {date}",
    YOUR_LESSON_COVER_REMOVED: "You teach your {groupName} lesson on {date} again",
    LESSON_CANCELLED: "{groupName} on {date} is cancelled",
    LESSON_RESTORED: "{groupName} on {date} takes place again",
    LESSON_MOVED: "{groupName} on {date} moved to {range}",
    LESSON_ROOM_CHANGED: "{groupName} on {date} is in room {classroomName}",
    TEACHER_NOTE_CHANGED: "New note for {groupName} on {date}",
    CENTER_CLOSED: "{centerName} is closed {dateFrom}–{dateTo}: {count} of your lessons don't take place",
    UNCOVERED_LESSONS: "{teacherName} has {count} uncovered lessons, first on {firstDate}",
  },
  roles: {
    Admin: "Admin",
    Viewer: "Viewer",
    Teacher: "Teacher",
  },
  unavailabilityReasons: {
    Sick: "Sick",
    Vacation: "Vacation",
    Holiday: "Holiday",
    RoomClosed: "Room closed",
    Other: "Other",
    Weekly: "Every week",
  },
  closureReasons: {
    Holiday: "Holiday",
    Other: "Other",
  },
  entityTypes: {
    Lesson: "Lesson",
    Group: "Group",
    Teacher: "Teacher",
    Classroom: "Classroom",
    Center: "Center",
    Course: "Course",
    User: "User",
    TravelTimes: "Travel times",
  },
  weekdays: {
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
  },
  plurals: {
    lessons: { one: "{count} lesson", few: "{count} lessons", many: "{count} lessons", other: "{count} lessons" },
    hours: { one: "{count} h", few: "{count} h", many: "{count} h", other: "{count} h" },
    minutes: { one: "{count} min", few: "{count} min", many: "{count} min", other: "{count} min" },
    excluded: {
      one: "{count} excluded",
      few: "{count} excluded",
      many: "{count} excluded",
      other: "{count} excluded",
    },
  },
};

export type Catalog = typeof en;
